import { useI18n } from 'vue-i18n'

const useCardStore = defineStore(
  // 唯一ID
  'card',
  () => {
    const { t } = useI18n()
    const openAddHolder = ref(false)
    const openAddCard = ref(false)
    // 卡介质
    const cardFormFactors = ref([
      {
        label: t('card_form_factors.virtual_card'),
        value: 'virtual_card',
        disable: false,
      },
      {
        label: t('card_form_factors.physical_card'),
        value: 'physical_card',
        disable: true,
      },
    ])
    // 卡类型
    const cardTypes = ref([
      {
        label: t('card_types.recharge'),
        value: 'recharge',
        disable: false,
      },
      {
        label: t('card_types.share'),
        value: 'share',
        disable: true,
      },
    ])
    // 卡组织
    const cardScheme = ref([
      {
        label: t('card_scheme.VISA'),
        value: 'VISA',
        active: 'visa_sm-active',
        inactive: 'visa_sm-inactive',
        create_show: false,
      },
      {
        label: t('card_scheme.MasterCard'),
        value: 'MasterCard',
        active: 'master-card_sm-active',
        inactive: 'master-card_sm-inactive',
        create_show: true,
      },
      {
        label: t('card_scheme.Discover'),
        value: 'Discover',
        active: 'discover_sm-active',
        inactive: 'discover_sm-inactive',
        create_show: true,
      },
    ])
    interface currency {
      label: string
      value: string
      iso: string
      symbol: string
      disable: boolean
    }
    // 卡本币
    const cardCurrency = ref<Array<currency>>([
      {
        label: 'USD',
        value: 'USD',
        iso: 'us',
        symbol: '$',
        disable: false,
      },
      {
        label: 'EUR',
        value: 'EUR',
        iso: 'eu',
        symbol: '€',
        disable: true,
      },
    ])
    // <el-tag type="primary">Tag 1</el-tag>
    // <el-tag type="success">Tag 2</el-tag>
    // <el-tag type="info">Tag 3</el-tag>
    // <el-tag type="warning">Tag 4</el-tag>
    // <el-tag type="danger">Tag 5</el-tag>
    // 卡状态
    const cardStatus = ref([
      {
        label: t('card_status.normal'),
        value: 'normal',
        type: 'success',
      },
      {
        label: t('card_status.pending_recharge'),
        value: 'pending_recharge',
        type: 'primary',
      },
      {
        label: t('card_status.unactivated'),
        value: 'unactivated',
        type: 'info',
      },
      {
        label: t('card_status.freezing'),
        value: 'freezing',
        type: 'warning',
      },
      {
        label: t('card_status.frozen'),
        value: 'frozen',
        type: 'danger',
      },
      {
        label: t('card_status.risk_frozen'),
        value: 'risk_frozen',
        type: 'danger',
      },
      {
        label: t('card_status.system_frozen'),
        value: 'system_frozen',
        type: 'danger',
      },
      {
        label: t('card_status.unfreezing'),
        value: 'unfreezing',
        type: 'primary',
      },
      {
        label: t('card_status.expired'),
        value: 'expired',
        type: 'danger',
      },
      {
        label: t('card_status.canceling'),
        value: 'canceling',
        type: 'warning',
      },
      {
        label: t('card_status.cancelled'),
        value: 'cancelled',
        type: 'danger',
      },
      {
        label: t('card_status.renewing'),
        value: 'renewing',
        type: 'primary',
      },
      {
        label: t('card_status.replacing'),
        value: 'replacing',
        type: 'primary',
      },
      {
        label: t('card_status.lost'),
        value: 'lost',
        type: 'danger',
      },
      {
        label: t('card_status.stolen'),
        value: 'stolen',
        type: 'danger',
      },
      {
        label: t('card_status.pin_lost'),
        value: 'pin_lost',
        type: 'danger',
      },
    ])
    // 持卡人状态
    const holderStatusList = ref([{
      label: t('holder_status.normal'),
      value: 'normal',
    }, {
      label: t('holder_status.disabled'),
      value: 'disabled',
    }, {
      label: t('holder_status.failed'),
      value: 'failed',
    }, {
      label: t('holder_status.pending'),
      value: 'pending',
    }])
    // 交易状态
    const transactionTypes = ref([
      { label: t('transaction_types.auth'), value: 'auth' },
      { label: t('transaction_types.corrective_auth'), value: 'corrective_auth' },
      { label: t('transaction_types.verification'), value: 'verification' },
      { label: t('transaction_types.void'), value: 'void' },
      { label: t('transaction_types.refund'), value: 'refund' },
      { label: t('transaction_types.corrective_refund'), value: 'corrective_refund' },
      { label: t('transaction_types.recharge'), value: 'recharge' },
      { label: t('transaction_types.recharge_return'), value: 'recharge_return' },
      { label: t('transaction_types.discard_recharge_return'), value: 'discard_recharge_return' },
      { label: t('transaction_types.service_fee'), value: 'service_fee' },
      { label: t('transaction_types.refund_reversal'), value: 'refund_reversal' },
      { label: t('transaction_types.fund_in'), value: 'fund_in' },
      { label: t('transaction_types.atm_inquiry'), value: 'atm_inquiry' },
      { label: t('transaction_types.atm_withdrawals'), value: 'atm_withdrawals' },
      { label: t('transaction_types.atm_inquiry_failed_return'), value: 'atm_inquiry_failed_return' },
      { label: t('transaction_types.atm_withdrawals_failed_return'), value: 'atm_withdrawals_failed_return' },
    ])
    // 收费类型
    const feeTypes = ref([
      { label: t('fee_types.create_card_fee'), value: 'create_card_fee' },
      { label: t('fee_types.discard_fee'), value: 'discard_fee' },
      { label: t('fee_types.loss_reporting_fee'), value: 'loss_reporting_fee' },
      { label: t('fee_types.renewal_fee'), value: 'renewal_fee' },
      { label: t('fee_types.replacement_fee'), value: 'replacement_fee' },
    ])
    // 卡历史状态
    const cardHistoryStatus = ref([
      {
        label: t('card_history_status.pending'),
        value: 'pending',
        type: 'primary',
      },
      {
        label: t('card_history_status.succeed'),
        value: 'succeed',
        type: 'success',
      },
      {
        label: t('card_history_status.failed'),
        value: 'failed',
        type: 'danger',
      },
    ])
    function findCardFormFactors(value: string) {
      return cardFormFactors.value.find(option => option.value === value)
        ?? {
          label: '',
          value: '',
        }
    }
    function findCardTypes(value: string) {
      return cardTypes.value.find(option => option.value === value)
        ?? {
          label: '',
          value: '',
        }
    }
    // 查找卡组织
    function findCardScheme(value: string) {
      return cardScheme.value.find(option => option.value === value)
        ?? {
          label: '',
          value: '',
          active: 'i-ep:question-filled',
          inactive: 'i-ep:question-filled',
          create_show: false,
        }
    }
    function findHolderStatusList(value: string) {
      return holderStatusList.value.find(option => option.value === value)
        ?? {
          label: '',
          value: '',
        }
    }
    // 查询指定卡类型
    function findCardState(value: string) {
      return cardStatus.value.find(option => option.value === value)
        ?? {
          label: '',
          value: '',
          type: '',
        }
    }
    function findCardCurrency(currency: string) {
      return cardCurrency.value.find(option => option.value === currency) ?? {
        label: '',
        value: '',
        iso: '',
        symbol: '',
        disable: false,
      }
    }
    function getCurrencySymbol(currency: string) {
      const item = cardCurrency.value.find(option => option.value === currency)
      return item?.symbol ?? ''
    }
    function findTransactionTypes(value: string) {
      return transactionTypes.value.find(option => option.value === value)
        ?? {
          label: '',
          value: '',
        }
    }
    function findFeeTypes(value: string) {
      return feeTypes.value.find(option => option.value === value)
        ?? {
          label: '',
          value: '',
        }
    }
    function findCardHistoryStatus(value: string) {
      return cardHistoryStatus.value.find(option => option.value === value)
        ?? {
          label: '',
          value: '',
          type: '',
        }
    }
    return {
      openAddHolder,
      openAddCard,
      cardFormFactors,
      cardTypes,
      cardScheme,
      cardCurrency,
      cardStatus,
      holderStatusList,
      transactionTypes,
      feeTypes,
      cardHistoryStatus,
      findCardFormFactors,
      findCardTypes,
      findCardScheme,
      findCardCurrency,
      findHolderStatusList,
      findCardState,
      getCurrencySymbol,
      findTransactionTypes,
      findFeeTypes,
      findCardHistoryStatus,
    }
  },
)

export default useCardStore
